import Vue from 'vue';
import 'maz-ui/lib/css/index.css';
import MazUi from 'maz-ui';

Vue.use(MazUi);
